






















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref, Watch } from 'vue-property-decorator';
import { HttpClient } from '@openticket/lib-shop';

const QUEUE_CHECK_INTERVAL = 5 * 60 * 1000;

@Component
export default class QueueCheck extends Vue {
    timeoutID: ReturnType<typeof setTimeout> | null = null;
    linkToShop: string = window.location.href;
    isInIFrame = true;

    @Ref('queue-check-dialog')
    dialog!: HTMLDialogElement;

    @Prop({ default: false })
    showing!: boolean;

    @Prop({ default: null })
    httpClient!: HttpClient | null;

    @Watch('showing', {
        immediate: true,
    })
    showQueueCheckModal() {
        if (this.showing && !this.dialog.open) {
            this.dialog.showModal();
        }
    }

    mounted() {
        this.setCheckTimeout(QUEUE_CHECK_INTERVAL);

        // If the cart is empty, trigger an update manually
        this.$shop.events.on(['timer', 'clear'], async () => {
            this.setCheckTimeout(1);
        });
    }

    created() {
        // DD-4E5B: Check if we're embedded and the queue gatekeeper check fails: link to a new page to try and recover
        try {
            this.isInIFrame = window.self !== window.top;
        } catch (e) {
            this.isInIFrame = true; // Probably in a cross-origin iframe
        }
    }

    setCheckTimeout(timeout: number) {
        if (this.timeoutID !== null) {
            clearTimeout(this.timeoutID);
        }

        this.timeoutID = setTimeout(async () => {
            if (
                Object.keys(this.$shop.cart.flatItems.tickets).length === 0 &&
                !(await this.isQueuedProperly())
            ) {
                this.showQueueCheck();
                return;
            }
            this.setCheckTimeout(QUEUE_CHECK_INTERVAL);
        }, timeout);
    }

    showQueueCheck() {
        this.$emit('show');
    }

    async isQueuedProperly(): Promise<boolean> {
        try {
            if (this.$shop) {
                return await this.$shop.isQueuedProperly();
            }
            return true;
        } catch (e) {
            console.error(e);
            return true;
        }
    }
}
